import React from 'react';
import { AlertCircle } from 'lucide-react';

const DataForSEOForm = ({
    dataForSEOParams,
    setDataForSEOParams,
    handleDataForSEOSearch,
    loadingDataForSEO,
    isPro
}) => {
    return (
        <div className="mt-6 p-6 bg-purple-50 rounded-xl border border-purple-200">
            <h3 className="text-xl font-bold text-purple-900 mb-4 flex items-center gap-2">
                Configurazione DataForSEO {isPro && <span className="text-xs bg-purple-600 text-white px-2 py-0.5 rounded-full">PRO</span>}
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="md:col-span-2">
                    <label className="block text-sm font-semibold text-gray-700 mb-1 flex items-center gap-2">
                        API Credentials (Base64)
                        <div className="group relative">
                            <AlertCircle size={14} className="text-gray-400 cursor-help" />
                            <div className="hidden group-hover:block absolute left-full ml-2 w-64 p-2 bg-gray-800 text-white text-xs rounded shadow-lg z-10">
                                Inserisci le tue credenziali API in formato login:password codificato in Base64
                            </div>
                        </div>
                    </label>
                    <input
                        type="password"
                        value={dataForSEOParams.apiCredentials}
                        onChange={(e) => setDataForSEOParams({ ...dataForSEOParams, apiCredentials: e.target.value })}
                        placeholder="Esempio: bG9naW46cGFzc3dvcmQ="
                        className="w-full p-2 border rounded focus:ring-2 focus:ring-purple-500 outline-none"
                    />
                </div>

                <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">Keyword</label>
                    <input
                        type="text"
                        value={dataForSEOParams.keyword}
                        onChange={(e) => setDataForSEOParams({ ...dataForSEOParams, keyword: e.target.value })}
                        placeholder="Es: scarpe da corsa"
                        className="w-full p-2 border rounded focus:ring-2 focus:ring-purple-500 outline-none"
                    />
                </div>

                <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">Language Code</label>
                    <input
                        type="text"
                        value={dataForSEOParams.languageCode}
                        onChange={(e) => setDataForSEOParams({ ...dataForSEOParams, languageCode: e.target.value })}
                        placeholder="it, en, es..."
                        className="w-full p-2 border rounded focus:ring-2 focus:ring-purple-500 outline-none"
                    />
                </div>

                <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">Device</label>
                    <select
                        value={dataForSEOParams.device}
                        onChange={(e) => setDataForSEOParams({ ...dataForSEOParams, device: e.target.value })}
                        className="w-full p-2 border rounded focus:ring-2 focus:ring-purple-500 outline-none"
                    >
                        <option value="mobile">Mobile</option>
                        <option value="desktop">Desktop</option>
                    </select>
                </div>

                <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">OS</label>
                    <select
                        value={dataForSEOParams.os}
                        onChange={(e) => setDataForSEOParams({ ...dataForSEOParams, os: e.target.value })}
                        className="w-full p-2 border rounded focus:ring-2 focus:ring-purple-500 outline-none"
                    >
                        <option value="android">Android (Mobile)</option>
                        <option value="ios">iOS (Mobile)</option>
                        <option value="windows">Windows (Desktop)</option>
                        <option value="macos">macOS (Desktop)</option>
                    </select>
                </div>
            </div>

            <button
                onClick={handleDataForSEOSearch}
                disabled={loadingDataForSEO}
                className={`w-full mt-6 py-3 rounded-lg font-bold text-white transition-all ${loadingDataForSEO ? 'bg-gray-400 cursor-not-allowed' : 'bg-purple-600 hover:bg-purple-700 shadow-md active:scale-95'
                    }`}
            >
                {loadingDataForSEO ? 'Ricerca in corso...' : 'Avvia Analisi DataForSEO'}
            </button>
        </div>
    );
};

export default DataForSEOForm;
